import React from 'react';
import { useData } from '../context/DataContext';
import { Link } from 'react-router-dom';
import SEO from './SEO';

const ProjectCard = ({ project }) => {
  return (
    <Link to={`/project/${project.id}`} className="block mb-24 group cursor-pointer">
      <div className="relative overflow-hidden bg-neutral-100 aspect-video mb-4 shadow-sm">
        <img 
          src={project.image} 
          alt={project.title}
          className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105"
          loading="lazy"
          onError={(e) => {
            e.target.style.display = 'none';
            e.target.parentElement.classList.add('bg-neutral-200');
          }}
        />
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-500" />
        
        {/* Overlay Hint */}
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <span className="bg-white/90 text-black px-4 py-2 text-xs uppercase tracking-widest font-bold">View Project</span>
        </div>
      </div>
      
      <div className="flex flex-col space-y-2">
        <div className="flex justify-between items-baseline border-b border-black pb-2">
          <h3 className="text-xl font-bold uppercase tracking-tighter group-hover:text-neutral-600 transition-colors">{project.title}</h3>
          <span className="text-sm font-mono text-neutral-600">{project.year}</span>
        </div>
        <div className="flex justify-between items-start pt-1">
          <p className="text-sm text-neutral-600 max-w-md leading-relaxed">{project.description}</p>
          <span className="text-xs uppercase tracking-widest text-neutral-400 ml-4">{project.category}</span>
        </div>
      </div>
    </Link>
  );
};

const Gallery = ({ category }) => {
  const { projects } = useData();
  const filteredProjects = category 
    ? projects.filter(p => p.category.toLowerCase().includes(category.toLowerCase()))
    : projects;

  const pageTitle = category ? `${category} Projects` : "Films & Works";
  const pageDescription = `Explore ${category || 'latest'} works by Leon Krykhtin, featuring AI films, generative art, and immersive installations.`;

  return (
    <div className="grid grid-cols-1 gap-y-12 animate-in fade-in slide-in-from-bottom-4 duration-700">
      <SEO 
        title={pageTitle}
        description={pageDescription}
        url={category ? `/${category.toLowerCase()}` : '/films'}
      />
      {filteredProjects.map((project) => (
        <ProjectCard key={project.id} project={project} />
      ))}
      
      {filteredProjects.length === 0 && (
        <div className="text-neutral-400 py-20 text-sm">
          No projects found in this category.
        </div>
      )}
    </div>
  );
};

export default Gallery;
